
export default function install(Vue) {
  Vue.prototype.$tools = {
    submitForm: submitForm,
    fixedDelay: fixedDelay
  };
}

function submitForm(opt) {
  //创建form表单
  let { url, method, target, data } = opt;
  let temp_form = document.createElement('form');
  temp_form.action = url;
  temp_form.target = target || '_self';
  temp_form.method = method || 'post';
  temp_form.style.display = 'none';
  //添加参数
  for (let name in data) {
    let opt = document.createElement('input');
    opt.name = name;
    opt.value = data[name];
    opt.type = 'hidden';
    temp_form.appendChild(opt);
  }
  document.body.appendChild(temp_form);
  //提交数据
  temp_form.submit();
  temp_form.remove();
}

function fixedDelay(func, delay) {
  let p = Promise.resolve();
  return function () {
    let proxyFunc = () => func.apply(this, Array.prototype.slice.apply(arguments));
    p = p.then(() => getPromise(proxyFunc, delay));
  };

  function getPromise(func, timeout) {
    return new Promise(function(resolve, reject) {
      try {
        func();
        setTimeout(resolve, timeout);
      } catch(e) {
        reject(e);
      }
    });
  }
}